<template>
  <div
    class="basic_product_detail_index"
    @mouseenter="module_isHover(true)"
    @mouseleave="module_isHover(false)"
    @dblclick="changeStyle('style')"
    ref="basic_product_detail_index"
    :style="{'--theme_color': theme_color}"
  >
    <div class="tooptipPart module_edit_btn" v-if="isHover">
      <my_hover_btn :tips="$t('widgets_basic_article_classification_index_336')" btnIcon="el-icon-edit" @changeStyle="changeStyle('style')"></my_hover_btn>
      <my_hover_btn
        :tips="$t('widgets_basic_article_classification_edit_330')"
        btnIcon="el-icon-magic-stick"
        @changeStyle="changeStyle('animation')"
        v-if="this.$store.state.app.view_pattern === 'pc'"
      ></my_hover_btn>
      <my_hover_btn
        :tips="$t('components_basic_addproduct_index_2077')"
        btnIcon="el-icon-edit-outline"
        @changeStyle="modify_product"
        v-if="this.$store.state.app.view_pattern === 'pc'"
      ></my_hover_btn>
    </div>
    <div class="data_empty" v-if="isEmpty">
      <i class="empty_tips_img"></i>
      <div class="empty_tips_text">{{$t('widgets_basic_product_detail_index_2762')}}</div>
    </div>
    <div class="view_pattern_pc" v-if="$store.state.app.view_pattern === 'pc' && !isEmpty">
      <div v-if="listArr.moduleStyle === 0 || listArr.moduleStyle === 3"
           :class="['moduleStyle moduleStyle0','module-style-'+listArr.moduleStyle]">
        <div class="product_detail_wrap">
          <div class="product_detail_left_content">
            <div class="detail_inner_wrap">
              <div class="magnifier detail_big_pic_content" id="magnifier">
                <div class="magnifier-container" id="magnifier-container">
                  <div class="images-cover" id="mask">
                    <img class="detail_big_pic" v-if="album.length === 0" src="/static/image/noimage.jpg">
                    <template v-else>
                      <template v-if="has_video && showImgIndex === 0">
                        <video autoplay="autoplay" :muted="true" :src="productInfo.video_url" controls="controls"
                              v-show="video_load_status" class="detail_big_pic" @canplaythrough="videoLoad"></video>
                        <img :src="album[0]" alt="" v-if="!video_load_status" class="detail_big_pic">
                      </template>
                      <img
                        v-else
                        :src="album[showImgIndex]"
                        class="detail_big_pic"
                        @click="imgUpdate"
                      />
                    </template>
                   </div>
                  <div class="move-view"></div>
                </div>
                <div class="magnifier-view"></div>
              </div>
              <!-- 这边要产品主图要修改 怎么显示视频 和 视频 和视频 封面   -->
              <div class="detail_small_pic_wrap" v-if="album.length > 0">
                <i class="iconfont icon-jiantouzuo" v-if="album.length >= 5" @click="swiper_prev"></i>
                <div class="jz_scroll_wrap">
                  <swiper ref="mySwiper" class="list_box"
                          :options="swiperOption">
                    <swiper-slide
                      v-for="(item, index) in album"
                      :key="index"
                      @mouseenter.native="change_showImgIndex(index)"
                    >
                      <img
                        class="position_center_middle"
                        :src="item"
                        :data-active="showImgIndex === index"
                      />
                      <i class="fa-play-circle fa play-icon" v-if="has_video && index === 0"></i>
                    </swiper-slide>
                  </swiper>
                </div>
                <i class="iconfont icon-jiantouyou" v-if="album.length >= 5" @click="swiper_next"></i>
              </div>
            </div>
          </div>
          <div class="product_detail_right_content">
            <div class="detail_title_wrap">
              <span class="detail_main_title">{{ productTitle }}</span>
              <div class="detail_func_wrap" v-if="pc_widgets_infor.share === 'open' && pc_widgets_infor.shareDisplayStyle !== 'tile'">
                <div class="detail_share" v-if="$store.state.app.language === 'zh-cn'">
                  <my_share_render :share-type="pc_widgets_infor.shareType"
                                   v-if="pc_widgets_infor.share === 'open' && pc_widgets_infor.shareDisplayStyle !== 'tile'"></my_share_render>
                </div>
                <div class="detail_share" v-if="$store.state.app.language !== 'zh-cn'">
                  <my_share_render :share-type="pc_widgets_infor.enShareType"
                                   v-if="pc_widgets_infor.share === 'open' && pc_widgets_infor.shareDisplayStyle !== 'tile'"></my_share_render>
                </div>
              </div>
            </div>
            <div class="detail_content detail-summary-content" v-html="productInfo.summary"></div>
            <!-- 属性 自定义属性 这个添加 购物车 要判断是不是显示 -->
            <div class="detail_other_message" v-if="!has_cart">
              <div class="detail_other" v-for="item in productParams" :key="item.id">
                <span class="detail_title">{{ item.title }}：</span>
                <span class="detail_value">{{ item.value }}</span>
              </div>
              <!-- 自定义的属性显示 -->
              <template v-if="false && productInfo.custom_attr && productInfo.custom_attr.length > 0">
                <div class="detail_other" v-for="(custom, index) in productInfo.custom_attr" :key="index">
                  <span class="detail_title">{{ custom.attr_name }}：</span>
                  <span class="detail_value">{{ custom.attr_value }}</span>
                </div>
              </template>
            </div>
            <!-- 购物车数据  -->
            <cart v-if="has_cart" :productInfo="productInfo">
              <template><product_button_wrap :module="module" :productInfo="productInfo"></product_button_wrap></template>
            </cart>
            <template v-else><product_button_wrap :module="module" :productInfo="productInfo"></product_button_wrap></template>
            <div class="detail_share_tile" v-if="pc_widgets_infor.share === 'open' && pc_widgets_infor.shareDisplayStyle === 'tile'">
              <my_share_render display-style="tile" title="" :share-type="pc_widgets_infor.shareType"
                v-if="$store.state.app.language === 'zh-cn'"></my_share_render>
              <my_share_render display-style="tile" title="" :share-type="pc_widgets_infor.enShareType"
                v-if="$store.state.app.language !== 'zh-cn'"></my_share_render>
            </div>
          </div>
        </div>
      </div>
      <div v-if="listArr.moduleStyle === 1" class="moduleStyle moduleStyle1">
        <div class="product_detail_wrap">
          <div class="product_detail_right_content">
            <div class="detail_title_wrap">
              <span class="detail_main_title">{{ productTitle }}</span>
              <div class="detail_func_wrap" v-if="listArr.shareRadio === 'open' && pc_widgets_infor.shareDisplayStyle !== 'tile'">
                <div class="detail_share" v-if="listArr.shareRadio === 'open' && $store.state.app.language === 'zh-cn'">
                  <my_share_render :share-type="pc_widgets_infor.shareType"
                                   v-if="pc_widgets_infor.share === 'open' && pc_widgets_infor.shareDisplayStyle !== 'tile'"></my_share_render>
                </div>
                <div class="detail_share" v-if="listArr.shareRadio === 'open' && $store.state.app.language !== 'zh-cn'">
                  <my_share_render :share-type="pc_widgets_infor.enShareType"
                                   v-if="pc_widgets_infor.share === 'open' && pc_widgets_infor.shareDisplayStyle !== 'tile'"></my_share_render>
                </div>
              </div>
            </div>
            <div class="detail_price_wrap" v-if="false">
              <div class="detail_price_content">
                <div class="detail_price_left">
                  <span class="detail_price">
                    <span class="detail_coin">￥</span>
                    <span class="detail_value">1.00</span>
                  </span>
                </div>
              </div>
            </div>
            <div class="detail_content detail-summary-content" v-html="productInfo.summary"></div>
            <div class="detail_other_message" v-if="!has_cart">
              <div class="detail_other" v-for="item in productParams" :key="item.id">
                <span class="detail_title">{{ item.title }}：</span>
                <span class="detail_value">{{ item.value }}</span>
              </div>
              <!-- 自定义的属性显示 -->
              <template v-if="false && productInfo.custom_attr && productInfo.custom_attr.length > 0">
                <div class="detail_other" v-for="(custom, index) in productInfo.custom_attr" :key="index">
                  <span class="detail_title">{{ custom.attr_name }}：</span>
                  <span class="detail_value">{{ custom.attr_value }}</span>
                </div>
              </template>
            </div>
            <cart v-if="has_cart" :productInfo="productInfo">
              <template><product_button_wrap :module="module" :productInfo="productInfo"></product_button_wrap></template>
            </cart>
            <template v-else><product_button_wrap :module="module" :productInfo="productInfo"></product_button_wrap></template>
            <div class="detail_share_tile" v-if="pc_widgets_infor.share === 'open' && pc_widgets_infor.shareDisplayStyle === 'tile'">
              <my_share_render display-style="tile" title="" :share-type="pc_widgets_infor.shareType"
                v-if="$store.state.app.language === 'zh-cn'"></my_share_render>
              <my_share_render display-style="tile" title="" :share-type="pc_widgets_infor.enShareType"
                v-if="$store.state.app.language !== 'zh-cn'"></my_share_render>
            </div>
          </div>
        </div>
      </div>
      <div v-if="listArr.moduleStyle === 2" class="moduleStyle moduleStyle2">
        <div class="product_detail_wrap">
          <div class="product_detail_left_content">
            <div class="detail_inner_wrap">
              <div class="detail_small_pic_wrap">
                <div class="jz_scroll_wrap">
                  <ul class="detail_small_pic_lists">
                    <li class="detail_small_pic_list" v-if="album.length === 0">
                      <img class="position_center_middle" src="/static/image/noimage.jpg"/>
                    </li>

                    <template v-else>
                      <!-- 存在视频 的情况 进行处理 -->
                      <li class="detail_small_pic_list" v-for="(item, index) in album" :key="index">
                        <template v-if="has_video && index == 0">
                          <video autoplay="autoplay" :muted="true" :src="productInfo.video_url" controls="controls"
                                 v-show="video_load_status" class="position_center_middle"
                                 @canplaythrough="videoLoad"></video>
                          <img :src="item" alt="" v-if="!video_load_status" class="position_center_middle">
                        </template>
                        <img class="position_center_middle" @click="imgUpdate(index, 'moduleStyle2')" :src="item"
                             v-else/>
                      </li>
                    </template>
                    <!-- <li class="detail_small_pic_list" v-else v-for="(item, index) in album" :key="index">
                      <img class="position_center_middle" :src="item"/>
                    </li> -->
                  </ul>
                </div>
              </div>
              <div class="detail_pagination_wrap" v-if="listArr.arrowRadio === 'block' && false">
                <div class="btn prev" @click="prev_page" v-if="prevPageID"
                     :style="prevPageID === '' ? 'color: #999' : ''">{{$t('widgets_basic_product_detail_index_2763')}}</div>
                <div class="btn next" @click="next_page" v-if="nextPageID"
                     :style="nextPageID === '' ? 'color: #999' : ''">{{$t('widgets_basic_product_detail_index_2764')}}</div>
              </div>
            </div>
          </div>
          <div class="product_img_radio" :style="imgRadioCSS">
            <div
              class="product_img_radio_item_wrap"
              v-for="(item, index) in album"
              :key="index"
              @click="scroll_dot(index)"
            >
              <div class="product_img_radio_item" :data-active="dotIndex === index"></div>
            </div>
          </div>
          <div class="product_detail_right_content" :style="rightContentCSS">
            <div class="detail_title_wrap">
              <span class="detail_main_title">{{ productTitle }}</span>
              <div class="detail_func_wrap" v-if="listArr.shareRadio === 'open' && pc_widgets_infor.shareDisplayStyle !== 'tile'">
                <div class="detail_share" v-if="listArr.shareRadio === 'open' && $store.state.app.language === 'zh-cn'">
                  <my_share_render :share-type="pc_widgets_infor.shareType"
                                   v-if="pc_widgets_infor.share === 'open' && pc_widgets_infor.shareDisplayStyle !== 'tile'"></my_share_render>
                </div>
                <div class="detail_share" v-if="listArr.shareRadio === 'open' && $store.state.app.language !== 'zh-cn'">
                  <my_share_render :share-type="pc_widgets_infor.enShareType"
                                   v-if="pc_widgets_infor.share === 'open' && pc_widgets_infor.shareDisplayStyle !== 'tile'"></my_share_render>
                </div>
              </div>
            </div>
            <div class="detail_content detail-summary-content" v-html="productInfo.summary"></div>
            <div class="detail_other_message" v-if="!has_cart">
              <div class="detail_other" v-for="item in productParams" :key="item.id">
                <span class="detail_title">{{ item.title }}：</span>
                <span class="detail_value">{{ item.value }}</span>
              </div>
              <!-- 自定义的属性显示 -->
              <template v-if="false && productInfo.custom_attr && productInfo.custom_attr.length > 0">
                <div class="detail_other" v-for="(custom, index) in productInfo.custom_attr" :key="index">
                  <span class="detail_title">{{ custom.attr_name }}：</span>
                  <span class="detail_value">{{ custom.attr_value }}</span>
                </div>
              </template>
            </div>
            <cart v-if="has_cart" :productInfo="productInfo">
              <template><product_button_wrap :module="module" :productInfo="productInfo"></product_button_wrap></template>
            </cart>
            <template v-else><product_button_wrap :module="module" :productInfo="productInfo"></product_button_wrap></template>
            <div class="detail_share_tile" v-if="pc_widgets_infor.share === 'open' && pc_widgets_infor.shareDisplayStyle === 'tile'">
              <my_share_render display-style="tile" title="" :share-type="pc_widgets_infor.shareType"
                v-if="$store.state.app.language === 'zh-cn'"></my_share_render>
              <my_share_render display-style="tile" title="" :share-type="pc_widgets_infor.enShareType"
                v-if="$store.state.app.language !== 'zh-cn'"></my_share_render>
            </div>
          </div>
        </div>
      </div>
      <div v-if="listArr.moduleStyle === 4"
           class="moduleStyle moduleStyle4 module-style-4">
        <div class="product_detail_wrap">
          <div class="product_detail_left_content">
            <div class="detail_inner_wrap">
              <div class="magnifier detail_big_pic_content" id="magnifier">
                 <div class="magnifier-container" id="magnifier-container">
                    <div class="images-cover" id="mask">
                      <img class="detail_big_pic" v-if="album.length === 0" src="/static/image/noimage.jpg">
                        <template v-else>
                          <template v-if="has_video && showImgIndex === 0">
                            <video autoplay="autoplay" :muted="true" :src="productInfo.video_url" controls="controls"
                                  v-show="video_load_status" class="detail_big_pic" @canplaythrough="videoLoad"></video>
                            <img :src="album[0]" alt="" v-if="!video_load_status" class="detail_big_pic">
                          </template>
                          <img
                            v-else
                            :src="album[showImgIndex]"
                            class="detail_big_pic"
                            @click="imgUpdate"
                          />
                        </template>
                    </div>
                    <div class="move-view"></div>
                  </div>
                 <div class="magnifier-view"></div>
              </div>
              <div class="detail_small_pic_wrap" v-if="album.length > 0">
                <i class="iconfont icon-jiantouzuo" v-if="album.length >= 5" @click="swiper_prev"></i>
                <div class="jz_scroll_wrap">
                  <swiper ref="mySwiper" class="list_box my-swiper-4"
                          :options="verticalSwiperOption">
                    <swiper-slide
                      v-for="(item, index) in album"
                      :key="index"
                      @mouseenter.native="change_showImgIndex(index)"
                    >
                      <img
                        class="position_center_middle"
                        :src="item"
                        :data-active="showImgIndex === index"
                      />
                      <i class="fa-play-circle fa play-icon" v-if="has_video && index === 0"></i>
                    </swiper-slide>
                  </swiper>
                </div>
                <i class="iconfont icon-jiantouyou" v-if="album.length >= 5" @click="swiper_next"></i>
              </div>
            </div>
          </div>
          <div class="product_detail_right_content">
            <div class="detail_title_wrap">
              <span class="detail_main_title">{{ productTitle }}</span>
              <div class="detail_func_wrap" v-if="pc_widgets_infor.share === 'open' && pc_widgets_infor.shareDisplayStyle !== 'tile'">
                <div class="detail_share" v-if="$store.state.app.language === 'zh-cn'">
                  <my_share_render :share-type="pc_widgets_infor.shareType"
                                   v-if="pc_widgets_infor.share === 'open' && pc_widgets_infor.shareDisplayStyle !== 'tile'"></my_share_render>
                </div>
                <div class="detail_share" v-if="$store.state.app.language !== 'zh-cn'">
                  <my_share_render :share-type="pc_widgets_infor.enShareType"
                                   v-if="pc_widgets_infor.share === 'open' && pc_widgets_infor.shareDisplayStyle !== 'tile'"></my_share_render>
                </div>
              </div>
            </div>
            <div class="detail_content detail-summary-content" v-html="productInfo.summary"></div>
            <div class="detail_other_message" v-if="!has_cart">
              <div class="detail_other" v-for="item in productParams" :key="item.id">
                <span class="detail_title">{{ item.title }}：</span>
                <span class="detail_value">{{ item.value }}</span>
              </div>
              <!-- 自定义的属性显示 -->
              <template v-if="false && productInfo.custom_attr && productInfo.custom_attr.length > 0">
                <div class="detail_other" v-for="(custom, index) in productInfo.custom_attr" :key="index">
                  <span class="detail_title">{{ custom.attr_name }}：</span>
                  <span class="detail_value">{{ custom.attr_value }}</span>
                </div>
              </template>
            </div>
            <cart v-if="has_cart" :productInfo="productInfo">
              <template><product_button_wrap :module="module" :productInfo="productInfo"></product_button_wrap></template>
            </cart>
            <template v-else><product_button_wrap :module="module" :productInfo="productInfo"></product_button_wrap></template>
            <div class="detail_share_tile" v-if="pc_widgets_infor.share === 'open' && pc_widgets_infor.shareDisplayStyle === 'tile'">
              <my_share_render display-style="tile" title="" :share-type="pc_widgets_infor.shareType"
                v-if="$store.state.app.language === 'zh-cn'"></my_share_render>
              <my_share_render display-style="tile" title="" :share-type="pc_widgets_infor.enShareType"
                v-if="$store.state.app.language !== 'zh-cn'"></my_share_render>
            </div>
          </div>
        </div>
      </div>
      <template v-if="listArr.moduleStyle === 5 || listArr.moduleStyle === 6">
        <one_img
          :module="module"
          :productInfo="productInfo"
          :productTitle="productTitle"
          :album="album"
          :showImgIndex="showImgIndex"
          :productParams="productParams"
        ></one_img>
      </template>
      <div class="detail_pagination_wrap" v-if="listArr.arrowRadio === 'block'">
        <div v-if="prevPageID" class="nav-btn-wrapper nav-btn-wrapper-left" @click="prev_page">
          <div class="btn prev" :style="prevPageID === '' ? 'color: #999' : ''">{{ getLang($t('widgets_basic_product_detail_index_2763')) }}</div>
          <span class="nav-btn-title" :title="prevPageTitle">{{ prevPageTitle }}</span>
        </div>
        <div v-if="nextPageID" class="nav-btn-wrapper nav-btn-wrapper-right" @click="next_page">
          <div class="btn next" :style="nextPageID === '' ? 'color: #999' : ''">{{ getLang($t('widgets_basic_product_detail_index_2764')) }}</div>
          <span class="nav-btn-title" :title="nextPageTitle">{{ nextPageTitle }}</span>
        </div>
      </div>
      <params :productParams="productParams" v-if="detailSpecificActive === -1 && has_cart && listArr.moduleStyle == 5"></params>
      <div class="product_specific_wrap" :class="`product_specific_wrap_${listArr.moduleStyle}`">
        <div class="product_specific_content">
          <div class="detail_specific_tab_wrap">
            <div
              class="detail_specific_tab"
              :data-active="detailSpecificActive === -1"
              @click="change_detailSpecific(-1)"
            >{{ getLang(listArr.tab_title_one ? listArr.tab_title_one : $t('components_basic_addproduct_index_2081') ) }}
            </div>
            <div
              class="detail_specific_tab"
              v-for="(item, index) in tabs"
              :key="index"
              :data-active="detailSpecificActive === index"
              @click="change_detailSpecific(index)"
            >{{ item.name }}
            </div>
          </div>
          <params :productParams="productParams" v-if="detailSpecificActive === -1 && has_cart && listArr.moduleStyle != 5"></params>
          <div class="detail_specfic_panel ul-set" v-html="detailSpecficPanel"
               v-if="detailSpecficType === 7 && detailSpecficPanel"></div>
          <div class="detail_specfic_panel" v-else-if="detailSpecficType === 8 && detailSpecficDownload.length > 0">
            <div class="download_item">
              <div class="download_name"><span style="font-weight: 700;">{{ getLang($t('widgets_basic_product_detail_index_2765')) }}</span></div>
              <div class="download_right">
                <div class="download_size" style="font-weight: 700;">{{$t('widgets_basic_download_edit_505')}}</div>
                <div class="download_time"><span style="font-weight: 700;">{{ getLang($t('widgets_basic_product_detail_index_2766')) }}</span></div>
                <div class="download_btn"></div>
              </div>
            </div>
            <div class="download_item" v-for="(item, index) in detailSpecficDownload" :key="index">
              <div class="download_name"><span>{{ item.name }}</span></div>
              <div class="download_right">
                <div class="download_size">{{ (item.size / 1024).toFixed(1) }}KB</div>
                <div class="download_time"><span>{{ item.time | timeConvert }}</span></div>
                <div class="download_btn"><a :href="`${item.path}?dl=1`" target="_self">{{ getLang($t('router_index_69')) }}</a></div>
              </div>
            </div>
          </div>
          <div class="detail_specfic_panel detail_specfic_panel_nodata" v-else>{{ getLang($t('widgets_basic_article_list_index_416')) }}</div>
        </div>
      </div>
    </div>
    <div class="view_pattern_mb" v-if="$store.state.app.view_pattern === 'mb' && !isEmpty">
      <div class="product_detail_wrap">
        <template v-if="listArr.moduleStyle !== 1">
          <div class="detail_big_pic_content" v-if="album.length === 0">
            <img class="detail_big_pic" src="/static/image/noimage.jpg">
          </div>
          <div class="product_detail_left_content" v-else>
            <swiper
              v-if="showMbSwiper"
              ref="mb_swiper"
              class="list_box"
              :options="mbSwiperOption"
              @slideChange="slide_change"
            >
              <swiper-slide v-for="(item, index) in album" :key="index">
                <div class="detail_big_pic_content">
                  <!-- <img class="position_center_middle" :src="item"/> -->
                  <template v-if="has_video && index === 0">
                    <video :muted="true" :src="productInfo.video_url" controls="controls" v-show="video_load_status"
                           class="position_center_middle video_view" @canplaythrough="videoLoad"></video>
                    <img :src="item" alt="" v-if="!video_load_status" class="position_center_middle video_view_frame">
                  </template>
                  <img
                    v-else
                    :src="item"
                    class="position_center_middle"
                  />
                </div>
              </swiper-slide>
            </swiper>
            <div class="swiper-pagination">{{ mbSwiperPage }} / {{ album.length }}</div>
          </div>
        </template>
        <div class="product_detail_right_content">
          <div class="detail_title_wrap">
            <span class="detail_main_title">{{ productTitle }}</span>
            <div class="detail_func_wrap" v-if="listArr.shareRadio === 'open' && pc_widgets_infor.shareDisplayStyle !== 'tile'">
              <div class="detail_share" v-if="listArr.shareRadio === 'open' && $store.state.app.language === 'zh-cn'">
                <my_share_render :share-type="pc_widgets_infor.shareType"
                                 v-if="pc_widgets_infor.share === 'open' && pc_widgets_infor.shareDisplayStyle !== 'tile'"></my_share_render>
              </div>
              <div class="detail_share" v-if="listArr.shareRadio === 'open' && $store.state.app.language !== 'zh-cn'">
                <my_share_render :share-type="pc_widgets_infor.enShareType"
                                 v-if="pc_widgets_infor.share === 'open' && pc_widgets_infor.shareDisplayStyle !== 'tile'"></my_share_render>
              </div>
            </div>
          </div>
          <cart style="margin:15px" v-if="has_cart" :productInfo="productInfo"></cart>
          <div class="detail_summary_content" v-if="productInfo.summary !== ''" v-html="productInfo.summary"></div>
          <div class="detail_other_message" @click="isShowMessage = true"
               v-if="productParams.length > 0 || (productInfo.custom_attr && productInfo.custom_attr.length > 0)">
            <div class="detail_other">
              <span class="detail_other-prefix">{{ getLang($t('widgets_basic_article_info_index_357')) }}</span>
              <template v-if="productParams.length > 0">
                <span class="detail_title">{{ productParams[0].title }}：</span>
                <span class="detail_value">{{ productParams[0].value }}</span>
              </template>
              <template v-else>
                <span class="detail_title">{{ productInfo.custom_attr[0].attr_name }}：</span>
                <span class="detail_value">{{ productInfo.custom_attr[0].attr_value }}</span>
              </template>

              <span class="detail_icon">
                <i class="iconfont icon-jiantouyou"></i>
              </span>
            </div>
          </div>
          <div class="detail_other_message_mobi_wrap" :data-active="isShowMessage"
               v-if="productParams.length > 0 || (productInfo.custom_attr && productInfo.custom_attr.length > 0)">
            <div class="detail_other_panel_bg" @click="isShowMessage = false"></div>
            <div class="detail_other_content">
              <div class="detail_other_message_mobi">
                <div class="detail_other_panel_title">{{ getLang($t('widgets_basic_product_detail_index_2767')) }}</div>
                <div class="detail_other_scroll_wrap">
                  <div class="detail_other" v-for="item in productParams" :key="item.id">
                    <span class="detail_title">{{ item.title }}：</span>
                    <span class="detail_value">{{ item.value }}</span>
                  </div>
                  <!-- 自定义的属性显示 -->
                  <template v-if="false && productInfo.custom_attr && productInfo.custom_attr.length > 0">
                    <div class="detail_other" v-for="(custom, index) in productInfo.custom_attr" :key="index">
                      <span class="detail_title">{{ custom.attr_name }}：</span>
                      <span class="detail_value">{{ custom.attr_value }}</span>
                    </div>
                  </template>
                </div>

              </div>
              <div class="detail_other_message_mobi_btn" @click="isShowMessage = false">{{ getLang($t('view_login_index_37')) }}</div>
            </div>
          </div>
          <template><product_button_wrap :module="module" :productInfo="productInfo"></product_button_wrap></template>
          <div class="detail_share_tile" v-if="pc_widgets_infor.share === 'open' && pc_widgets_infor.shareDisplayStyle === 'tile'">
            <my_share_render display-style="tile" title="" :share-type="pc_widgets_infor.shareType"
              v-if="$store.state.app.language === 'zh-cn'"></my_share_render>
            <my_share_render display-style="tile" title="" :share-type="pc_widgets_infor.enShareType"
              v-if="$store.state.app.language !== 'zh-cn'"></my_share_render>
          </div>

        </div>
      </div>
      <div class="product_specific_wrap">
        <div class="product_specific_content">
          <div class="detail_specific_tab_wrap">
            <div
              class="detail_specific_tab"
              :data-active="detailSpecificActive === -1"
              @click="change_detailSpecific(-1)"
            >
              <span>{{ getLang(listArr.tab_title_one ? listArr.tab_title_one : $t('components_basic_addproduct_index_2081') ) }}</span>
            </div>
            <div
              class="detail_specific_tab"
              v-for="(item, index) in tabs"
              :key="index"
              :data-active="detailSpecificActive === index"
              @click="change_detailSpecific(index)"
            ><span>{{ item.name }}</span></div>
          </div>
         
          <div class="detail_specfic_panel ul-set" v-html="detailSpecficPanel"
               v-if="detailSpecficType === 7 && detailSpecficPanel"></div>
          <div class="detail_specfic_panel " v-else-if="detailSpecficType === 8 && detailSpecficDownload.length > 0">
            <div class="download_item">
              <div class="download_name"><span style="font-weight: 700;">{{$t('widgets_basic_product_detail_index_2765')}}</span></div>
              <div class="download_right">
                <div class="download_size" style="font-weight: 700;">{{$t('widgets_basic_download_edit_505')}}</div>
                <div class="download_btn"></div>
              </div>
            </div>
            <div class="download_item" v-for="(item, index) in detailSpecficDownload" :key="index">
              <div class="download_name"><span>{{ item.name }}</span></div>
              <div class="download_right">
                <div class="download_size">{{ (item.size / 1024).toFixed(1) }}KB</div>
                <div class="download_btn"><a :href="`${item.path}?dl=1`" target="_self">{{$t('router_index_69')}}</a></div>
              </div>
            </div>
          </div>
          <div class="detail_specfic_panel detail_specfic_panel_nodata" v-else>{{$t('widgets_basic_article_list_index_416')}}</div>
        </div>
      </div>
    </div>
    <div
      class="wechat_show_dialog"
      :class="{wechat_show_dialog_mb: $store.state.app.view_pattern === 'mb'}"
      v-show="showVisiable"
    >
      <div class="wechat_show_box">
        <div class="box_header">
          <i class="iconfont icon-chuyidong" @click="showVisiable = false"></i>
        </div>
        <div class="box_body">
          <img :src="listArr.qrCodeImg"/>
          <p>{{$t('widgets_basic_product_detail_index_2768')}}</p>
        </div>
      </div>
    </div>
    <basic_addProduct v-if='editVisible' :editId='editId' :showTag.sync='editVisible' @submit_sure="submit_product"
                      @closed="editVisible = false"></basic_addProduct>
    <!-- 图片放大 -->
    <img-scale :show-pop.sync="img_scale_show" :img-url="album[showImgIndex]" :video-update="video_update"></img-scale>
  </div>
</template>

<script>
import i18n from '../../language/index'

import {getGoodsEdit, getPreNext, getShopRole} from '@/api/app.js'
import {getTopByWindow, getLeftByWindow} from '@/utils/utils.js'
import imgScale from '@/components/img_scale'
import linkData from '@/base/linkData'
import p from '../basic_plugin_code/p'
import one_img from "./components/one_img";
import product_button_wrap from "./components/product_button_wrap";
import cart from './components/cart'
import params from './components/params'
export default {
  name: 'basic_product_detail_index',
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    has_cart(){
      return this.$store.state.app.road_type && this.productInfo.p_5 != 0
    },
    theme_color() {
      return this.$store.state.myRender.common.theme_color
    },
    pc_widgets_infor() {
      return this.module.data.pc_widgets_infor
    },
    listArr() {
      return this.module.data.listArr
    },
    has_video() { // 是否存在视频
      return this.productInfo.video_url
    },
    video_update() {
      return this.has_video ? this.album.slice(1) : this.album
    },
    is_road_type() {
      return this.$store.getters['app/is_road_type']
    }
  },
  watch: {
    'listArr.paraList': {
      handler(val) {
        this.get_productParams(val)
      },
      deep: true
    },
    '$store.state.app.view_pattern'(val) {
      this.$nextTick(() => {
        if (val === 'mb') {
          this.mbSwiperPage = 1
          setTimeout(() => {
            this.showMbSwiper = true
          }, 300)
        } else {
          this.showMbSwiper = false
        }
        this.scroll_change()
      })
    },
    'listArr.moduleStyle'(val) {
      setTimeout(() => {
        if (this.$refs.mySwiper && this.$refs.mySwiper.swiper) {
          let direction = val === 4 ? 'vertical' : 'horizontal'
          this.$refs.mySwiper.swiper.changeDirection(direction, true)
        }
      }, 100)
    }
  },
  data() {
    return {
      cart_role: false,
      img_scale_show: false,
      video_load_status: false,
      isEmpty: true,
      dialogVisible: true,
      editVisible: false,
      editId: -1,
      isHover: false,
      timer: null,
      album: [],
      showImgIndex: 0,
      productInfo: {},
      productTitle: i18n.t('widgets_basic_product_detail_index_2769'),
      productParams: [],
      tabs: [],
      swiperOption: {
        direction: "horizontal",
        slidesPerView: 5,
        slidesPerGroup: 1
      },
      verticalSwiperOption: {
        direction: "vertical",
        slidesPerView: 5,
        slidesPerGroup: 1,
      },
      detailSpecificActive: -1,
      detailSpecficPanel: i18n.t('widgets_basic_product_detail_index_2770'),
      detailSpecficType: 7,
      detailSpecficDownload: [],
      dotIndex: 0,
      rightContentCSS: {
        top: '77px',
        left: '51%',
        width: '40%',
        position: 'absolute',
      },
      imgRadioCSS: {
        position: 'absolute',
        top: '262px',
        left: '12px'
      },
      prevPageID: '',
      prevPageTitle: '',
      nextPageID: '',
      nextPageTitle: '',
      mbSwiperOption: {
        watchOverflow: true,
        loop: true
      },
      mbSwiperPage: 1,
      isShowMessage: false,
      showVisiable: false,
      showMbSwiper: false,
      pre_detail: null, // 上一个
      next_detail: null,// 下一个
      sysProductParamNames : ["brand", "model", "minimum", "standard", "unit", "pack"],
    }
  },
  created() {
    // 新加字段兼容
    this.fixField()
    if (typeof this.$store.state.myRender.common.displayContactRadio == 'undefined') {
      this.$set(this.$store.state.myRender.common, 'displayContactRadio', 'block')
    }
    if (typeof this.listArr.email == 'undefined') {
      this.$set(this.listArr, 'email', '')
    }
    if (typeof this.listArr.tab_title_one == 'undefined') {
      this.$set(this.listArr, 'tab_title_one', 'Product Details')
    }
    if (typeof this.module.data.pc_widgets_infor.enShareType == 'undefined') {
      this.$set(this.module.data.pc_widgets_infor, 'enShareType', ['twitter','skype','wechat','facebook','linkedin'])
    }
    if (typeof this.module.data.pc_widgets_infor.shareDisplayStyle == 'undefined') {
      this.$set(this.module.data.pc_widgets_infor, 'shareDisplayStyle', 'default')
    }
    this.paraListAddLink() // 属性添加链接
  },
  mounted() {
    // 判断平台，初始化swiper
    if (this.$store.state.app.view_pattern === 'mb') {
      this.mbSwiperPage = 1
      this.showMbSwiper = true
    } else {
      this.showMbSwiper = false
    }
    // 产品详情
    if (!this.$route.query.id) {
      return
    }
    this.editId = Number(this.$route.query.id)
    this.get_goodsEdit()
    // 上一页, 下一页
    getPreNext({id: this.$route.query.id, module_name: 'product'}).then((res) => {
      if (res.code === 200) {
        if (res.data.pre) {
          this.prevPageID = res.data.pre.goods_id
          this.prevPageTitle = res.data.pre.title
          this.pre_detail = res.data.pre
        }
        if (res.data.next) {
          this.nextPageID = res.data.next.goods_id
          this.nextPageTitle = res.data.next.title
          this.next_detail = res.data.next
        }
      } else {
        // this.$message.error(res.message)
      }
    }).catch(error => {
      this.$message.error(error)
    })
    this.init_fixed()
    this.getShopRole()
  },
  methods: {    
    async getShopRole(){
      let res = await getShopRole()
      if(res.code ==200) {
        this.cart_role = res.data.cart
        this.$store.commit('app/SET_cart_role', res.data.cart);
      }
    },
    paraListAddLink() { // 4.7.2 产品详情属性添加链接
      let paraList = this.module.data.listArr.paraList;
      if (paraList[0].link === undefined) {
        this.module.data.listArr.paraList.forEach((item, index) => {
          this.$set(item, 'link', {
            ...linkData,
            linkType: 'none'
          })
        })
      }
    },
    imgUpdate(index, type) { //点击图片进行放大处理的显示
      this.img_scale_show = true
      if (type === 'moduleStyle2') { // 第三种进行处理
        this.showImgIndex = index
      }
    },
    videoLoad() {
      console.log('视频加载完成')
      this.video_load_status = true
      $('.video_view').css('display', 'block')
      $('.video_view_frame').css('display', 'none')
    },
    module_isHover(val) {
      this.isHover = val
    },
    changeStyle(tabName) {
      this.templet.changeStyle(this.module, tabName)
    },
    modify_product() {
      this.editVisible = true
    },
    submit_product() {
      this.get_goodsEdit()
      this.editVisible = false
    },
    get_goodsEdit() {
      getGoodsEdit({id: this.$route.query.id}).then((res) => {
        if (res.code === 200) {
          // 数据为空是info是个空数组
          if (Array.isArray(res.data.info)) {
            this.isEmpty = true
            return
          } else {
            this.isEmpty = false
          }
          if (res.data.info.album) { // 这个地方是存放的产品主图 也要加上视频 和视频 封面
            this.album = res.data.info.album
            if (this.album.length <= 1) {
              this.mbSwiperOption.loop = false
            }
          }
          // 判断产品信息是否有视频
          if (res.data.info.video_url) { // ?sec=1&w=300
            let img = res.data.info.video_img ? res.data.info.video_img : `${res.data.info.video_url}?sec=1`
            this.album = [img, ...this.album];
          }
          this.productTitle = res.data.info.name
          this.tabs = res.data.info.tabs.filter((item) => item.content !== '')
          this.textRich = res.data.info.intro
          this.detailSpecficPanel = this.textRich
          if (res.data.info.custom_attr && res.data.info.custom_attr.length > 0) {
            res.data.info.custom_attr = res.data.info.custom_attr.filter((item) => item.attr_name !== '')
          }
          this.productInfo = res.data.info
          if(this.productInfo.summary){
            this.productInfo.summary = this.productInfo.summary.replace(/\n/g,"<br>")
          }
          this.getParaListCustomAttr()                  
          this.get_productParams(this.listArr.paraList)
        } else {
          this.$message.error(res.message)
        }
      }).catch(error => {
        this.$message.error(error)
      })
    },
    // 自定义参数也放到paraList
    getParaListCustomAttr(){
      let attrNames = []
      let paraListNames = []
      let paraListValue = {}
      let custom_value = {}
      let that = this
      this.productInfo.custom_attr.map((item) => {
        custom_value[item.attr_name] = item.attr_value
        attrNames.push(item.attr_name)
      })
      this.listArr.paraList.map((item) => {
        if(attrNames.indexOf(item.id) > -1){
          paraListNames.push(item.id)
          paraListValue[item.id] = item
        }
      })
      this.listArr.paraList = this.listArr.paraList.filter(item => this.sysProductParamNames.indexOf(item.id) > -1)
      this.productInfo.custom_attr.map((item) => {
        if(paraListNames.indexOf(item.attr_name) > -1){
          that.listArr.paraList.push({...paraListValue[item.attr_name], value: custom_value[item.attr_name]})
        }else{
          that.listArr.paraList.push({
            title: item.attr_name,
            id: item.attr_name,
            show: true,
            value: custom_value[item.attr_name],
            link:{
                ...linkData,
                linkType: 'none'
            }
          })
        }
      })
    },
    change_detailSpecific(index) {
      this.detailSpecificActive = index
      if (index === -1) {
        this.detailSpecficType = 7
        this.detailSpecficPanel = this.textRich
      } else {
        if (this.tabs[this.detailSpecificActive].show_type === 7) {
          this.detailSpecficType = 7
          this.detailSpecficPanel = this.tabs[this.detailSpecificActive].content
        }
        if (this.tabs[this.detailSpecificActive].show_type === 8) {
          this.detailSpecficType = 8
          // 字符串转数组对象
          this.detailSpecficDownload = []
          this.detailSpecficDownload = JSON.parse(this.tabs[this.detailSpecificActive].content)
        }
      }
    },
    swiper_prev() {
      this.$refs.mySwiper.swiper.slidePrev()
      if (this.showImgIndex > 0) {
        this.showImgIndex--
      }
    },
    swiper_next() {
      this.$refs.mySwiper.swiper.slideNext()
      if (this.showImgIndex < this.album.length - 1) {
        this.showImgIndex++
      }
    },
    change_showImgIndex(index) {
      this.showImgIndex = index
    },
    get_productParams(paraList) {
      let productParams = []
      paraList.map((item, index) => {
        if (item.show && this.productInfo[item.id] !== '') {
          item.title = this.getLang(item.title)
          if (!(item.id === 'minimum' && this.productInfo[item.id] === 0)) { // 判断起订量是不是显示
            if(this.sysProductParamNames.indexOf(item.id) > -1){
              productParams.push({
                ...item,
                value: this.productInfo[item.id]
              })
            }else{
              productParams.push({
                ...item,
              })
            }            
          }
        }
      })
      if (this.$store.state.app.language == 'en-us') { // 英语 单词首字母大写
        productParams = productParams.map(item => {
          item.title = item.title.split(" ").map(it => {
            return it.slice(0, 1).toUpperCase() + it.slice(1)
          }).join(" ")
          return item
        })
      }
      this.productParams = productParams
    },
    init_fixed() {
      $(window).scroll(() => {
        this.scroll_change()
      })
    },
    scroll_change() {
      let _this = this
      let widgetDom = this.$refs.basic_product_detail_index
      if (!widgetDom) {
        return
      }
      if (!(this.listArr.moduleStyle === 2 && this.$store.state.app.view_pattern === 'pc')) {
        return
      }
      let placeholderHeight = $('.topBar').height()  // 头部设置栏高度
      if (this.$store.state.myRender.common.fixed_header === 'true' && this.$store.state.myRender.common.header_display === 'true') {
        placeholderHeight += $('.myheader').height()  // 固定头部高度
      }
      let offsetTop = getTopByWindow(widgetDom)
      let padding = 20  // moduleStyle2的padding
      let boxHeight = $('.basic_product_detail_index .moduleStyle2').height()
      let rightBoxHeight = $('.basic_product_detail_index .product_detail_right_content').height()
      let rightTopLine = $(window).scrollTop() + placeholderHeight - 57 - padding // 57为top的77减去设置绝对高度20
      let rightBottomLine = $(window).scrollTop() + placeholderHeight
      let leftBoxHeight = $('.basic_product_detail_index .product_img_radio').height()
      let leftPosTop = 262 // 262为预计高度
      // 右边滚动内容
      if (rightTopLine >= offsetTop && rightBottomLine < offsetTop + boxHeight - rightBoxHeight) {
        this.rightContentCSS = {
          top: `${20 + placeholderHeight}px`,
          left: `${$('.basic_product_detail_index .product_detail_right_content')[0].getBoundingClientRect().left}px`, // 50是误差
          width: `${$('.moduleStyle2 .product_detail_wrap').width() * 0.4}px`,
          position: 'fixed'
        }
        // 设置滚动的dotIndex
        let step = $('.product_detail_left_content .detail_small_pic_list').eq(0).width() + 36 // 36是marginTop
        let contentScroll = ($(window).scrollTop() + placeholderHeight) - offsetTop
        let dotIndex = parseInt(contentScroll / step)
        this.dotIndex = dotIndex
      } else if (rightBottomLine > offsetTop + boxHeight - rightBoxHeight) {
        // 向下滚出dom
        this.rightContentCSS = {
          top: `${boxHeight - rightBoxHeight}px`,
          left: '51%',
          width: '40%',
          position: 'absolute'
        }
      } else {
        this.rightContentCSS = {
          top: '77px',
          left: '51%',
          width: '40%',
          position: 'absolute'
        }
      }
      // 左边滚动内容
      if (rightTopLine >= offsetTop && rightBottomLine < offsetTop + boxHeight + padding - leftBoxHeight - leftPosTop) {
        this.imgRadioCSS = {
          position: 'fixed',
          top: `${262 + 77}px`,
          left: `${12 + getLeftByWindow($('.moduleStyle2 .product_detail_wrap')[0])}px`
        }
      } else if (rightBottomLine > offsetTop + boxHeight + padding - leftBoxHeight - leftPosTop) {
        // 向下滚出dom
        this.imgRadioCSS = {
          position: 'absolute',
          top: `${boxHeight - leftBoxHeight - leftPosTop}px`,
          left: '12px'
        }
      } else {
        this.imgRadioCSS = {
          position: 'absolute',
          top: '262px',
          left: '12px'
        }
      }
    },
    scroll_dot(index) {
      let step = $('.product_detail_left_content .detail_small_pic_list').eq(0).width() + 36 // 36是marginTop
      let widgetDom = this.$refs.basic_product_detail_index
      let offsetTop = getTopByWindow(widgetDom)
      let contentScroll = offsetTop + step * index
      $(window).scrollTop(contentScroll)
    },
    prev_page() {
      if (this.prevPageID) {
        let query = {id: this.prevPageID}
        if (this.is_road_type) query.tag_id = this.pre_detail.tag_ids
        if (this.$store.state.app.is_change) {
          this.$confirm(i18n.t('widgets_basic_article_info_index_360'), i18n.t('view_public_topbar_23'), {
            confirmButtonText: i18n.t('widgets_basic_article_info_index_361'),
            cancelButtonText: i18n.t('view_public_topbar_11'),
            center: true,
            appendToBody: true
          }).then(() => {
            this.$store.state.main_dialog.main_dialog_isShow = false
            this.$router.push({
              name: 'product',
              query
              // : {id: this.prevPageID}
            })
          }).catch(action => {
            console.log('取消弹窗')
          })
        } else {
          if (this.is_road_type) query.tag_id = this.pre_detail.tag_ids
          this.$router.push({
            name: 'product',
            query
            // : {id: this.prevPageID}
          })
        }

      }
    },
    next_page() {
      if (this.nextPageID) {
        let query = {id: this.nextPageID}
        if (this.is_road_type) query.tag_id = this.next_detail.tag_ids
        if (this.$store.state.app.is_change) {
          this.$confirm(i18n.t('widgets_basic_article_info_index_360'), i18n.t('view_public_topbar_23'), {
            confirmButtonText: i18n.t('widgets_basic_article_info_index_361'),
            cancelButtonText: i18n.t('view_public_topbar_11'),
            center: true,
            appendToBody: true
          }).then(() => {
            this.$store.state.main_dialog.main_dialog_isShow = false
            this.$router.push({
              name: 'product',
              query
              // : {id: this.nextPageID}
            })
          }).catch(action => {
            console.log('取消弹窗')
          })
        } else {
          this.$store.state.main_dialog.main_dialog_isShow = false
          this.$router.push({
            name: 'product',
            query
            // : {id: this.nextPageID}
          })
        }
      }
    },
    slide_change() {
      this.mbSwiperPage = this.$refs.mb_swiper.swiper.realIndex + 1
    },
    show_contact_box() {
      if (this.listArr.contactRadio === 'phone') {
        this.$message.error(i18n.t('components_set_link_components_phone_consultation_2462'))
      } else {
        this.showVisiable = true
      }
    },
    fixField() {
      if (!Array.isArray(this.listArr.contactRadio)) {
        this.$set(this.listArr, "contactRadio", [this.listArr.contactRadio]);
      }
      if (typeof this.listArr.scale_type == 'undefined') {
        this.listArr.scale_type = 'block'
      }
    }
  },
  components: {
    imgScale,
    one_img,
    product_button_wrap,
    cart,
    params
  }
}
</script>

<style lang="scss" scoped>
@import '~@/css/magnifier.scss';
.basic_product_detail_index {
  cursor: default;

  .data_empty {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 90px 0;

    .empty_tips_img {
      display: block;
      width: 120px;
      height: 150px;
      margin: 0 auto 28px;
      background: url(~@/assets/image/default_icon.png) 2px -482px;
    }

    .empty_tips_text {
      margin-top: 28px;
      font-size: 16px;
      line-height: 24px;
      color: #333;
    }
  }

  .view_pattern_pc {
    padding: 20px;

    .detail_pagination_wrap {
      display: flex;
      width: 100%;
      flex-direction: row;
      justify-content: space-between;
      padding-top: 18px;

      .nav-btn-wrapper {
        cursor: pointer;
        display: flex;
        width: 50%;
        align-items: center;
      }

      .nav-btn-wrapper-left {
        padding-right: 20px;
      }

      .btn {
        box-sizing: border-box;
        display: inline-flex;
        width: 80px;
        height: 30px;
        line-height: 28px;
        text-align: center;
        border-radius: 15px;
        border: 1px solid #e9e9e9;
        cursor: pointer;
        justify-content: center;
        font-size: 14px;
        color: #333;
      }

      .nav-btn-title {
        flex: 1;
        padding-left: 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        font-size: 14px;
        color: #333;
      }
    }

    .moduleStyle0, .moduleStyle4 {
      position: relative;
      font-size: 14px;

      .product_detail_wrap {
        width: 100%;
        font-size: 14px;

        .product_detail_left_content {
          width: 43.75%;
          float: left;

          .detail_inner_wrap {
            width: auto;
            margin-right: 4.8%;
            position: relative;

            .detail_big_pic_content {
              position: relative;
              box-sizing: border-box;
              width: 100%;
              padding-bottom: 100%;
              border: 1px solid #eee;

              .detail_big_pic {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                margin: auto;
                width: auto;
                height: auto;
                max-width: 100%;
                max-height: 100%;
              }
            }
          }

          .detail_small_pic_wrap {
            position: relative;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            margin-top: 14px;

            .iconfont {
              position: absolute;
              width: 12px;
              cursor: pointer;

              &.icon-jiantouzuo {
                left: 0;
                margin-left: 2px;
              }

              &.icon-jiantouyou {
                right: 0;
                margin-right: 2px;
              }
            }

            .jz_scroll_wrap {
              width: 92%;
              display: inline-block;
              margin-left: 4%;
              margin-right: 4%;

              /deep/ .swiper-container {
                padding-bottom: 1px;
                padding-right: 1px;
              }

              .list_box {
                .swiper-wrapper {
                  .swiper-slide {
                    position: relative;
                    font-size: 0;
                    padding-bottom: 17.2%;
                    padding-left: 17.2%;

                    .position_center_middle {
                      position: absolute;
                      top: 0;
                      left: 0;
                      width: 100%;
                      height: 100%;
                      border: 1px solid transparent;
                      object-fit: contain;
                      cursor: pointer;

                      &[data-active] {
                        border-color: var(--theme_color);
                      }
                    }

                    .play-icon {
                      position: absolute;
                      font-size: 30px;
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                      color: var(--theme_color)
                    }
                  }
                }
              }
            }
          }

          .detail_pagination_wrap {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-top: 18px;

            .btn {
              box-sizing: border-box;
              display: inline-block;
              width: 80px;
              height: 30px;
              line-height: 28px;
              text-align: center;
              border-radius: 15px;
              border: 1px solid #e9e9e9;
              cursor: pointer;
            }
          }
        }

        .product_detail_right_content {
          width: 56.25%;
          float: left;
          box-sizing: border-box;

          .detail_title_wrap {
            font-size: 20px;
            line-height: 40px;
            color: #333;
            word-break: break-word;
            margin-top: 10px;
            display: flex;
            align-items: center;

            .detail_main_title {
              min-width: calc(100% - 120px);
              padding-right: 20px;
              box-sizing: border-box;
              overflow: hidden;
              font-size: 20px;
              line-height: 40px;
              color: #333;
              word-break: break-word;
            }

            .detail_func_wrap {
              // line-height: 0;
              min-width: 120px;
              text-align: left;
              border-left: 1px solid #f0f0f0;
              padding-left: 19px;
              box-sizing: border-box;

              .detail_share {
                display: inline-block;
                font-size: 14px;
                color: #333;
                vertical-align: middle;
                text-align: center;
                cursor: pointer;

                /deep/ .jz_share_text {
                  .u-icon {
                    display: block;
                    width: 40px;
                    height: 20px;
                    line-height: 20px;
                    font-size: 24px;
                    text-align: center;
                    margin: 0 !important;
                  }
                }
              }
            }

            .detail_share_tile {
              margin: 10px 0px;
            }
          }

          .detail_content {
            margin-top: 6px;
            padding: 10px 10px 10px 0;
          }

          .detail_other_message {
            margin-left: 0px;
            margin-top: 6px;
            transition: margin-left 0.5s;

            .detail_other {
              border-bottom: none !important;
              line-height: 40px;

              .detail_title {
                font-size: 16px;
                color: #333;
              }

              .detail_value {
                font-size: 16px;
                color: #333;
                opacity: 0.9;
              }
            }
          }

          /deep/ .product_button_wrap {
            align-items: center;
            margin-top: 30px;
            padding-left: 0px;
            
          }
        }
      }

      &.module-style-3 {
        .product_detail_wrap {
          .product_detail_left_content {
            float: right;
          }
        }
      }


    }

    .moduleStyle4 {
      &.module-style-4 {
        .product_detail_wrap {
          .product_detail_left_content {
            width: 100%;
            float: none;

            .detail_big_pic_content {
              width: 90%;
              height: 0;
              padding-bottom: 450px;
              float: left;
              margin-left: calc(50% - 250px);
            }

            @media screen and (max-width: 1700px) {
              .detail_big_pic_content {
                width: 85%;
              }
            }

            @media screen and (max-width: 1200px) {
              .detail_big_pic_content {
                width: 80%;
              }
            }

            @media screen and (max-width: 900px) {
              .detail_big_pic_content {
                width: 70%;
              }
            }

            .detail_small_pic_wrap {
              width: 100px;
              height: 450px;
              display: inline-block;
              margin-top: 0;
            }

            .iconfont.icon-jiantouzuo {
              top: 0;
              left: 0;
              right: 0;
              margin-left: auto;
              margin-right: auto;
              transform: rotate(90deg);
            }

            .iconfont.icon-jiantouyou {
              left: 0;
              right: 0;
              margin-left: auto;
              margin-right: auto;
              transform: rotate(90deg);
              bottom: 0;
            }

            .jz_scroll_wrap {
              height: 400px;

              .list_box {
                height: 400px;
                margin-top: 25px;
                margin-bottom: 25px;
              }
            }
          }

          .product_detail_right_content {
            clear: both;
            width: 100%;
            margin-top: 15px;
          }
        }
      }
    }

    .moduleStyle1 {
      .product_detail_wrap {
        overflow: hidden;
        width: 100%;
        font-size: 14px;

        .product_detail_right_content {
          display: block;
          width: 100%;

          .detail_title_wrap {
            display: flex;
            align-items: flex-start;
            max-width: 100%;

            .detail_main_title {
              min-width: 0;
              font-size: 20px;
              color: #333;
              white-space: normal;
              display: inline-block;
              padding-right: 20px;
            }

            .detail_func_wrap {
              border-left: 0;
              padding-left: 0;
              padding-top: 6px;

              .detail_share {
                display: inline-block;
                font-size: 14px;
                color: #333;
                vertical-align: middle;
                cursor: pointer;

                /deep/ .g-share-render-box {
                  .jz_share_text {
                    .u-icon {
                      display: block;
                      width: 40px;
                      height: 35px;
                      line-height: 20px;
                      font-size: 24px;
                      text-align: center;
                      margin: 0 !important;
                    }

                    .u-share_title {
                      display: none;
                    }
                  }

                  .jz_share_list {
                    right: auto;
                    left: -30px;
                    text-align: center;

                    &::before {
                      right: auto;
                      left: 45px;
                    }
                  }
                }
              }
            }
          }

          .detail_content {
            margin-top: 6px;
            padding: 10px 0;
          }

          .detail_other_message {
            margin-left: 0px;
            margin-top: 6px;
            display: flex;
            flex-wrap: wrap;
            transition: margin-left 0.5s;

            .detail_other {
              width: 50%;
              padding: 13px 0;
              display: flex;
              padding-right: 15px;
              line-height: 30px;
              box-sizing: border-box;
              border-bottom: 1px solid rgba(245, 245, 245, 1);

              .detail_title {
                font-size: 16px;
                font-weight: 700;
                color: #333;
                display: block;
                width: 120px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                box-sizing: border-box;
                padding: 0 0px;
              }

              .detail_value {
                font-size: 16px;
                color: #333;
                opacity: 0.9;
                width: calc(100% - 120px);
              }
            }
          }

          /deep/ .product_button_wrap {
            align-items: center;
            margin-top: 30px;

          }

          .detail_pagination_wrap {
            margin-top: 30px;
            margin-left: 10px;

            .btn {
              box-sizing: border-box;
              display: inline-block;
              margin: 0 6px;
              width: 80px;
              height: 30px;
              line-height: 28px;
              text-align: center;
              border-radius: 15px;
              border: 1px solid #e9e9e9;
              cursor: pointer;
            }
          }
        }
      }
    }

    .moduleStyle2 {
      .product_detail_wrap {
        position: relative;
        display: inline-block;
        overflow: visible;
        width: 100%;

        .product_img_radio {
          position: absolute;
          top: 262px;
          left: 12px;
          display: block;
          max-width: 20px;
          padding: 2px;
          width: 5%;

          .product_img_radio_item_wrap {
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;

            .product_img_radio_item {
              width: 4px;
              height: 4px;
              background: #c1c1c1;
              border-radius: 50%;
              transition: 0.2s;

              &[data-active] {
                border: 2px solid grey;
                width: 15px;
                height: 15px;
                background: 0 0;
              }
            }
          }
        }

        .product_detail_left_content {
          max-width: 700px;
          width: 50%;
          float: left;
          padding-right: 4.8%;
          margin-left: 5%;

          .detail_inner_wrap {
            margin-right: 0;

            .detail_small_pic_wrap {
              margin-top: 14px;
              position: relative;

              .jz_scroll_wrap {
                width: 100%;
                margin-left: 0;
                margin-right: 0;
                display: inline-block;

                .detail_small_pic_lists {
                  width: 100%;
                  height: 100%;
                  overflow: hidden;
                  font-size: 0;
                  white-space: nowrap;

                  .detail_small_pic_list {
                    position: relative;
                    border: 1px solid #ebebeb;
                    margin-left: 0;
                    margin-top: 36px;
                    width: 100%;
                    display: block;
                    padding: 0 0 100% 0;
                    box-sizing: border-box;

                    .position_center_middle {
                      position: absolute;
                      top: 0;
                      left: 0;
                      bottom: 0;
                      right: 0;
                      width: auto;
                      height: auto;
                      max-width: 100%;
                      max-height: 100%;
                      margin: auto;
                    }
                  }
                }
              }
            }

            .detail_pagination_wrap {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              margin: 30px 10px 0;

              .btn {
                box-sizing: border-box;
                display: inline-block;
                margin: 0 6px;
                width: 80px;
                height: 30px;
                line-height: 28px;
                text-align: center;
                border-radius: 15px;
                border: 1px solid #e9e9e9;
                cursor: pointer;
              }
            }
          }
        }

        .product_detail_right_content {
          top: 77px;
          left: 51%;
          padding-left: 30px;
          width: 40%;
          z-index: 95;
          position: absolute;
          float: left;
          background: #fff;

          .detail_title_wrap {
            display: flex;

            .detail_main_title {
              max-width: calc(100% - 80px);
              min-width: calc(100% - 80px);
              font-size: 20px;
              flex-shrink: 1;
              display: inline-block;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              padding-right: 20px;
              color: #333;
            }

            .detail_func_wrap {
              text-align: right;
              min-width: 80px;
              padding-left: 19px;
              box-sizing: border-box;

              .detail_share {
                margin-top: 6px;
                margin-right: 8px;
                display: inline-block;
                font-size: 14px;
                color: #333;
                vertical-align: middle;

                /deep/ .g-share-render-box {
                  .jz_share_text {
                    .u-icon {
                      display: block;
                      width: 40px;
                      height: 35px;
                      line-height: 20px;
                      font-size: 24px;
                      text-align: center;
                      margin: 0 !important;
                    }

                    .u-share_title {
                      display: none;
                    }
                  }

                  .jz_share_list {
                    text-align: center;

                    &::before {
                      right: 24px;
                    }
                  }
                }
              }
            }
          }

          .detail_price_wrap {
            margin-top: 35px;
            background: #f7f7f7;
            width: 100%;
            height: 100px;

            .detail_price_content {
              position: relative;

              .detail_price_left {
                padding: 30px 0 0 29px;

                .detail_price {
                  font-weight: 700;
                  color: #2b2b2b;
                  font-size: 24px;
                }
              }

              .detail_price_right {
                display: inline-block;
                position: absolute;
                right: 5%;
                bottom: 5%;

                .detail_sales {
                  display: inline-block;
                  font-size: 14px;
                  color: #666;
                }
              }
            }
          }

          .detail_other_message {
            margin: 15px 0;
            transition: margin-left 0.5s;

            .detail_other {
              line-height: 0;
              padding: 11.5px 0;
              border-bottom: 1px solid #f5f5f5;

              .detail_title {
                margin-right: 0;
                padding: 0 8px;
                //width: 120px;
                display: inline-block;
                width: 9em;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
                font-size: 16px;
                color: #333;
                text-align: left;
                font-weight: 700;
                margin-right: 10px;
                line-height: 30px;
                padding-left: 0;
                box-sizing: border-box;
              }

              .detail_value {
                line-height: 30px;
                display: inline-block;
                color: #333;
                font-size: 16px;
                opacity: 0.9;
                vertical-align: top;
                width: calc(100% - 140px);
              }
            }
          }

          /deep/ .product_button_wrap {
            align-items: center;
            margin-top: 30px;
            padding-left: 0;

          }
        }
      }

      .detail_content {
        margin-top: 6px;
        padding: 10px 10px 10px 0;
      }
    }

    .product_specific_wrap {
      clear: both;
      margin-top: 80px;

      .product_specific_content {
        box-sizing: border-box;
        width: 100%;
        font-size: 0;

        .detail_specific_tab_wrap {
          border: 1px solid #f0f0f0;
          color: var(--theme_color);

          .detail_specific_tab {
            position: relative;
            display: inline-block;
            text-align: center;
            width: 160px;
            box-sizing: border-box;
            border-right: 1px solid #f0f0f0;
            font-size: 15px;
            line-height: 54px;
            cursor: pointer;
            transition: all 0.3s;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            padding: 0 8px;

            &[data-active]::before {
              content: " ";
              box-sizing: border-box;
              position: absolute;
              top: -1px;
              left: 0;
              border: 2px solid;
              width: 100%;
            }
          }
        }
      }

      .detail_specfic_panel {
        margin: 25px 15px;
        font-size: 14px;
        color: #333;

        .download_item {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          height: 50px;
          line-height: 50px;
          border-bottom: 1px dashed #e7e7e7;

          .download_name {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .download_right {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-left: 30px;

            .download_size {
              overflow: hidden;
              width: 80px;
              flex: 0 0 80px;
              text-align: right;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .download_time {
              margin: 0 20px;
              width: 150px;
              text-align: center;
            }

            .download_btn {
              width: 80px;
              height: 34px;
              line-height: 34px;
              text-align: center;
              border-radius: 3px;

              a {
                display: inline-block;
                background: #f2f3f5;
                width: 80px;
                height: 34px;
                border-radius: 2px;
                color: #657180;
                cursor: pointer;

                &:hover {
                  background: var(--theme_color) !important;
                  color: #fff !important;
                }
              }
            }
          }
        }

        &.ul-set {
          /deep/ {
            ol li {
              list-style: decimal;
            }

            ul li {
              list-style: disc;
            }
          }
        }

      }

      .detail_specfic_panel_nodata {
        padding: 0 20px;
        font-size: 14px;
        text-align: left;
      }
    }

    .product_specific_wrap_5, .product_specific_wrap_6 {
      margin-top: 30px !important;

      .detail_specific_tab_wrap {
        border: none !important;

        .detail_specific_tab {
          border: 1px solid #f0f0f0;
          border-radius: 5px;

          &[data-active] {
            background-color: var(--theme_color) !important;
            color: #fff !important;
          }

          &[data-active]::before {
            border: none !important;
          }
        }
      }
    }

    .product_specific_wrap_5 {
      .product_specific_content {
        display: flex;

        .detail_specific_tab_wrap {
          display: flex;
          flex-direction: column;
          width: 160px;
          margin-right: 5px;
        }

        .detail_specfic_panel {
          width: calc(100% - 160px);
        }
      }

    }
  }

  .view_pattern_mb {
    .product_detail_wrap {
      .detail_big_pic_content {
        position: relative;
        width: 100%;
        padding-bottom: 100%;

        img {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          max-width: 100%;
          max-height: 100%;
        }
      }

      .product_detail_left_content {
        position: relative;

        .list_box {
          width: 100%;

          .detail_big_pic_content {
            position: relative;
            padding-bottom: 100%;

            .position_center_middle {
              position: absolute;
              top: 0;
              bottom: 0;
              left: 0;
              right: 0;
              margin: auto;
              width: auto;
              height: auto;
              max-width: 100%;
              max-height: 100%;
            }
          }
        }

        .swiper-pagination {
          position: absolute;
          bottom: 14px;
          right: 14px;
          left: auto !important;
          width: 50px;
          height: 24px;
          line-height: 24px;
          border-radius: 12px;
          text-align: center;
          background: rgba(0, 0, 0, 0.3);
          font-size: 14px;
          color: #fff;
        }
      }

      .product_detail_right_content {
        width: 100%;

        .detail_title_wrap {
          display: flex;
          align-items: center;
          margin: 10px 15px 0 15px;
          font-size: 18px;
          line-height: 26px;
          width: auto;
          color: #333;

          .detail_main_title {
            line-height: 26px;
            width: 90%;
            padding: 0;
            min-width: calc(100% - 120px);
            padding-right: 20px;
            box-sizing: border-box;
            overflow: hidden;
            display: -webkit-box;
          }

          .detail_func_wrap {
            display: inline-block;
            border: none;
            text-align: left;
            padding: 0;
            min-width: auto;
            margin-left: 15px;

            .detail_share {
              display: inline-block;
              font-size: 14px;
              color: #333;
              vertical-align: middle;
              text-align: center;
              cursor: pointer;

              /deep/ .g-share-render-box {
                .jz_share_text {
                  .u-icon {
                    display: block;
                    width: 40px;
                    height: 35px;
                    line-height: 35px;
                    font-size: 24px;
                    text-align: center;
                    margin: 0 !important;
                  }

                  .u-share_title {
                    display: none;
                  }
                }
              }
            }
          }
        }

        .detail_summary_content {
          margin: 15px;
          word-wrap: break-word;
          font-size: 14px;
          color: #666;
          line-height: 1.6;
        }

        .detail_other_message {
          margin-left: 0;
          margin-top: 16px;
          padding-top: 16px;
          background-color: #f8f8f8;

          .detail_other {
            width: 100%;
            padding: 0;
            display: flex;
            line-height: 60px;
            color: #333;
            font-size: 16px;
            background-color: #fff;
            cursor: pointer;

            .detail_other-prefix {
              width: 50px;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
              font-size: 14px;
              color: #999;
              margin-left: 15px;
              margin-right: 5.3%;
            }

            .detail_title {
              width: 90px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              font-size: 14px;
              color: #666;
              line-height: 60px;
            }

            .detail_value {
              width: calc(100% - 140px);
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              flex-grow: 1;
            }

            .detail_icon {
              display: inline-block;
              color: #999;
              margin-right: 12px;
              height: 60px;
              line-height: 60px;
              cursor: pointer;
            }
          }
        }

        .detail_other_message_mobi_wrap {
          overflow: hidden;
          position: fixed;
          bottom: 0;
          left: 0;
          height: 0;
          width: 100%;
          z-index: 99999;
          transition: 0.5s background-color, 0s 0.5s height;

          .detail_other_panel_bg {
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0);
            transition: 0.5s background-color;
            cursor: pointer;
          }

          .detail_other_content {
            position: absolute;
            bottom: 0;
            height: 0;
            width: 100%;
            transition: 0.5s height;

            .detail_other_message_mobi {
              height: 100%;
              width: 100%;
              box-sizing: border-box;
              bottom: 0;
              background-color: #fff;
              padding-bottom: 50px;
              overflow-y: auto;

              .detail_other_panel_title {
                height: 60px;
                line-height: 60px;
                box-sizing: border-box;
                text-align: center;
                font-size: 16px;
              }

              .detail_other_scroll_wrap {
                width: 100%;
                overflow-y: auto;
                height: calc(100% - 60px);
                padding: 0 10px;
                box-sizing: border-box;

                .detail_other {
                  width: 100%;
                  padding: 0;
                  display: flex;
                  border-bottom: 1px solid #ebebeb;
                  font-size: 0;
                  color: #666;

                  .detail_title {
                    display: inline-block;
                    height: 55px;
                    line-height: 55px;
                    width: 90px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    font-size: 14px;
                    color: #666;
                  }

                  .detail_value {
                    // display: inline-block;
                    vertical-align: top;
                    width: calc(100% - 90px);
                    padding-left: 2%;
                    box-sizing: border-box;
                    min-height: 50px;
                    line-height: 20px;
                    font-size: 14px;
                    color: #666;
                    display: flex;
                    align-items: center;
                  }
                }
              }
            }

            .detail_other_message_mobi_btn {
              position: absolute;
              bottom: 0;
              width: 100%;
              height: 50px;
              line-height: 50px;
              font-size: 16px;
              color: #fff;
              text-align: center;
              background-color: var(--theme_color);
              cursor: pointer;
            }
          }

          &[data-active] {
            height: 100%;
            transition: 0.3s background-color;

            .detail_other_panel_bg {
              background-color: rgba(0, 0, 0, 0.5);
            }

            .detail_other_content {
              height: 80%;
            }
          }
        }

        /deep/ .product_button_wrap {
          position: fixed;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 50px;
          z-index: 10;
          padding-left: 0;
          margin-top: 0;
          align-items: center;


        }
      }
    }

    .product_specific_wrap {
      margin-top: 0;
      padding-top: 16px;
      background-color: #f8f8f8;

      .product_specific_content {
        box-sizing: border-box;
        width: 100%;
        color: #333;
        font-size: 0;
        background-color: #fff;

        .detail_specific_tab_wrap {
          display: flex;
          flex-direction: row;
          color: #333;
          font-size: 0;
          overflow: auto;

          .detail_specific_tab {
            position: relative;
            flex: 1;
            padding: 0 6px;
            border: none;
            color: var(--theme_color);
            font-size: 14px;
            line-height: 60px;
            font-weight: 700;
            text-align: center;
            white-space: nowrap;

            span {
              position: relative;
              display: inline-block;
              height: 100%;
              min-width: 56px;
            }

            &[data-active] span::before {
              content: " ";
              border-bottom: 2px solid var(--theme_color);
              position: absolute;
              bottom: 0;
              right: 0;
              left: 0;
              margin: auto;
              width: 100%;
            }
          }
        }
      }

      .detail_specfic_panel {
        overflow: hidden;
        background-color: #fff;
        margin: 15px 15px;
        font-size: 14px;
        color: #333;

        &.ul-set {
          /deep/ {
            ol li {
              list-style: decimal;
            }

            ul li {
              list-style: disc;
            }
          }
        }

        .download_item {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          height: 50px;
          line-height: 50px;
          border-bottom: 1px dashed #e7e7e7;

          .download_name {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .download_right {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-left: 30px;

            .download_size {
              overflow: hidden;
              width: 80px;
              flex: 0 0 80px;
              text-align: right;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .download_btn {
              margin-left: 10px;
              width: 80px;
              height: 34px;
              line-height: 34px;
              text-align: center;
              border-radius: 3px;

              a {
                display: inline-block;
                background: #f2f3f5;
                width: 80px;
                height: 34px;
                border-radius: 2px;
                color: #657180;
                cursor: pointer;

                &:hover {
                  background: var(--theme_color) !important;
                  color: #fff !important;
                }
              }
            }
          }
        }

        &.detail_specfic_panel_nodata {
          padding: 0 20px;
          text-align: left;
        }

        /deep/ img {
          max-width: 100%;
        }
      }
    }
  }

  .wechat_show_dialog {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 2000;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.5);
    transition: all 0.3s;

    .wechat_show_box {
      padding: 25px;
      width: 440px;
      height: 450px;
      background: #fff;
      border-radius: 5px;
      animation: fade ease 0.3s;

      .box_header {
        text-align: right;
        line-height: 45px;

        i {
          color: #aaa;
          font-size: 26px;
          cursor: pointer;
        }
      }

      .box_body {
        text-align: center;

        img {
          width: 256px;
          height: 256px;
          object-fit: cover;
        }

        p {
          text-align: center;
          margin-top: 30px;
          font-size: 18px;
          color: #333;
          margin-bottom: 10px;
        }
      }
    }

    &.wechat_show_dialog_mb {
      .wechat_show_box {
        padding: 0 0 20px;
        width: 280px;
        min-height: 265px;
        height: auto;

        .box_header {
          i {
            margin-right: 10px;
            font-size: 24px;
          }
        }

        .box_body {
          img {
            width: 210px;
            height: 210px;
          }

          p {
            font-size: 16px;
          }
        }
      }
    }
  }
}

.basic_product_detail_index .view_pattern_pc .moduleStyle4 .product_detail_wrap .product_detail_right_content .detail_title_wrap .detail_main_title {
  min-width: 0;
  font-size: 20px;
  color: #333;
  white-space: normal;
  display: inline-block;
  padding-right: 20px;
}

.basic_product_detail_index .view_pattern_pc .moduleStyle4 .product_detail_wrap .product_detail_right_content .detail_title_wrap .detail_func_wrap {
  border-left: 0;
  padding-left: 0;
  padding-bottom: 6px;
}

.basic_product_detail_index .view_pattern_pc .moduleStyle4 .product_detail_wrap .product_detail_right_content .detail_title_wrap .detail_func_wrap .detail_share /deep/ .g-share-render-box .jz_share_text .u-share_title {
  display: none;
}

@keyframes fade {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.view_pattern_mb /deep/ .product_advisory_email {
  flex-flow: 0.5;
  height: 100%;
  line-height: 50px;
  width: 100%;
  color: #fff;
  font-size: 15px;
  text-align: center;
  transition: background-color .3s;
  cursor: pointer;
  background-color: var(--theme_color);
}

/deep/ .product_advisory_email span {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/deep/ .product_advisory_email i {
  font-size: 18px;
}

.view_pattern_pc /deep/ .product_advisory_email {
  width: auto;
  max-width: 100%;
  padding: 0 15px;
  height: 42px;
  color: #fff;
  font-size: 15px;
  line-height: 42px;
  text-align: center;
  border-radius: 21px;
  background-color: var(--theme_color);
  transition: background-color .3s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.view_pattern_pc {
  .product_advisory_btn, /deep/ .product_advisory_email {
    // margin-right: 10px;
  }
}

.view_pattern_pc /deep/ .product_button_wrap {
  display: block;

  .product_advisory_btn, .product_advisory_email {
    display: inline-block;
    margin-bottom: 10px;
    vertical-align: top;
  }
}

/deep/ .product_advisory_email {
  i, span {
    vertical-align: middle;
  }
}

.view_pattern_mb {
  /deep/ .product_button_wrap {
    display: flex;
  }

  /deep/ .btn-product-contact:not(:last-child) {
    margin-right: 2px;
  }

  .product_advisory_btn {
    flex: 2;
  }

  /deep/ .product_advisory_email {
    flex-basis: 80px;
    flex-grow: 0;
  }
  .product_advisory_email_new {
    flex-basis: 80px;
    flex-grow: 1 !important;
  }
}

.view_pattern_pc {
  /deep/ .product_advisory_email {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.view_pattern_mb{
  /deep/ .product_button_wrap {
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 50px;
      z-index: 10;
      padding-left: 0;
      margin-top: 0;
      align-items: center;

      .product_advisory_btn {
        flex: 1 1;
        height: 100%;
        line-height: 50px;
        width: 200px;
        color: #fff;
        font-size: 15px;
        text-align: center;
        transition: background-color .3s;
        cursor: pointer;
        border:none;
        border-radius: 0;
      }
    }
   .product_button_wrap {
      
      .btn-product-contact:not(:last-child) {
        margin-right: 2px;
      }

      .product_advisory_btn {
        flex: 2;
      }
      .product_advisory_email_new {
        flex-grow: 1 !important;
      }

      .product_advisory_email {
        width: 80px;
        flex-basis: 80px;
        flex-grow: 0;
      }
      .btn-contact-wechat span{
        margin-left: 2px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/widgets/basic_product_detail/index.vue